// import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
// import { Label, Modal, ModalBody, ModalHeader } from "reactstrap";
// import { BsEye } from "react-icons/bs";
// import { FaPencilAlt, FaSearch, FaTrash, FaUpload } from "react-icons/fa";
// import { toast } from "react-toastify";
// import { useMutation, useQuery, useQueryClient } from "react-query";

// import Breadcrumbs from "../../Component/Common/Breadcrumbs";
// import ConfirmModal from "../../Component/Common/ConstomModal/ConfirmModal";
// import CustomPagination from "../../Component/Common/CustomPagination";
// import { CustomReactTable } from "../../Component/Common/CustomReactTable";
// import Dropdown from "../../Component/Common/Dropdown";
// import InputModal from "../../Component/Common/ConstomModal/InputModal";
// import { InputField } from "../../Component/Common/InputField";
// import useDebounce from "../../helper/customhook";
// import { checkFormError, getResposeError } from "../../helper";
// import { getStorage } from "../../helper/storage";
// import {
//   addBlaBle,
//   deleteBlaBle,
//   getBlaBleDetails,
//   getBlaBleList,
//   updateBlaBle,
// } from "../../services/blaBleService";
// import { blaBleValidation } from "../../helper/errorSchema";
// import UserContext from "../../helper/UserContext";
// import "./BlaBle.css";

// const PAGE_SIZE = 20;
// const MAX_IMAGE_SIZE = 2 * 1024 * 1024;
// const IMAGE_TYPES = ["image/jpeg", "image/jpg", "image/png", "image/webp"];
// const PLACEHOLDER_AVATAR =
//   "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='160' height='160' viewBox='0 0 160 160'%3E%3Crect width='160' height='160' fill='%23eef2f7'/%3E%3Ccircle cx='80' cy='61' r='31' fill='%2395a3b8'/%3E%3Cpath d='M28 139c8-32 29-49 52-49s44 17 52 49' fill='%2395a3b8'/%3E%3C/svg%3E";

// const basicFields = [
//   { name: "name", label: "Name", required: true },
//   { name: "mobile", label: "Mobile Number", required: true, maxLength: 10 },
//   { name: "epic_no", label: "EPIC Number", required: true },
//   { name: "assembly_no", label: "Assembly Number" },
//   { name: "booth_no", label: "Booth Number" },
// ];

// const extraFields = Array.from({ length: 10 }, (_, index) => ({
//   name: `extra${index + 1}`,
//   label: `Extra ${index + 1}`,
// }));

// const descriptionFields = Array.from({ length: 5 }, (_, index) => ({
//   name: `description${index + 1}`,
//   label: `Description ${index + 1}`,
// }));

// const initialForm = [...basicFields, ...extraFields, ...descriptionFields].reduce(
//   (acc, field) => ({ ...acc, [field.name]: "" }),
//   {
//     profile_image: "",
//     is_active: true,
//     remove_profile_image: false,
//   }
// );

// const getRecordId = (item) => item?.uuid || item?.id;

// const getImageUrl = (item) =>
//   item?.profile_image ||
//   item?.profile_image_url ||
//   item?.image ||
//   item?.image_url ||
//   "";

// const valueOrDash = (value) =>
//   value === null || value === undefined || value === "" ? "-" : value;

// const getAssemblyNumbers = (userLogin, user) =>
//   user?.appDetails?.assembly_number ||
//   userLogin?.appDetails?.assembly_number ||
//   [];

// const normalizeRecord = (item = {}) => ({
//   ...initialForm,
//   ...item,
//   mobile: item?.mobile || item?.mobile_number || item?.mobile_no || "",
//   epic_no: item?.epic_no || item?.epic_number || item?.epic || "",
//   assembly_no: item?.assembly_no || item?.assembly_number || "",
//   booth_no: item?.booth_no || item?.booth_number || "",
//   type: item?.type || "BLA",
//   gender: item?.gender || "",
//   rel_name: item?.rel_name || item?.relative_name || "",
//   party_name: item?.party_name || "",
//   address: item?.address || "",
//   profile_image: getImageUrl(item),
//   is_active:
//     item?.is_active === undefined || item?.is_active === null
//       ? item?.status !== false
//       : item?.is_active,
// });

// const buildPayload = (formValue, userLogin) => {
//   const formData = new FormData();
//   [...basicFields, ...extraFields, ...descriptionFields].forEach(({ name }) => {
//     if (name === "assembly_no") {
//       formData.append("ac_no", formValue?.assembly_no ?? "");
//       formData.append("assembly_no", formValue?.assembly_no ?? "");
//       return;
//     }
//     formData.append(name, formValue?.[name] ?? "");
//   });

//   formData.append("is_active", formValue?.is_active ? "true" : "false");

//   if (userLogin?.app_name) {
//     formData.append("app_name", userLogin.app_name);
//   }
//   if (userLogin?.party_name) {
//     formData.append("party_name", userLogin.party_name);
//   }

//   if (formValue?.profile_image instanceof File) {
//     formData.append("profile_image", formValue.profile_image);
//   }
//   if (formValue?.remove_profile_image) {
//     formData.append("remove_profile_image", "true");
//   }

//   return formData;
// };

// export const BlaBle = () => {
//   const userLogin = getStorage("logged-in");
//   const { user } = useContext(UserContext);
//   const queryClient = useQueryClient();
//   const fileRef = useRef(null);
//   const [isOpen, setIsOpen] = useState(false);
//   const [isEdit, setIsEdit] = useState(false);
//   const [isViewOpen, setIsViewOpen] = useState(false);
//   const [openDel, setOpenDel] = useState(false);
//   const [deleteId, setDeleteId] = useState("");
//   const [formValue, setFormValue] = useState(initialForm);
//   const [initialValue, setInitialValue] = useState(initialForm);
//   const [formError, setFormError] = useState({});
//   const [preview, setPreview] = useState(PLACEHOLDER_AVATAR);
//   const [selectedRecord, setSelectedRecord] = useState(null);
//   const [isLoadding, setIsLoadding] = useState(false);
//   const [selectedAssembly, setSelectedAssembly] = useState(null);
//   const [filter, setFilter] = useState({
//     limit: PAGE_SIZE,
//     offset: 0,
//     currentPage: 0,
//     search: "",
//     ordering: "-id",
//     ac_no: "",
//     app_name: userLogin?.app_name,
//     party_name: userLogin?.party_name,
//   });
//   const debouncedFilter = useDebounce(filter, 500);
//   const assemblyOptions = useMemo(
//     () =>
//       getAssemblyNumbers(userLogin, user)
//         .filter(Boolean)
//         .map((assemblyNumber) => ({
//           label: String(assemblyNumber),
//           value: String(assemblyNumber),
//         })),
//     [userLogin, user]
//   );
//   const hasRequiredListParams = Boolean(
//     debouncedFilter?.app_name &&
//       debouncedFilter?.party_name &&
//       debouncedFilter?.ac_no
//   );
//   const listParamError = !filter?.app_name
//     ? "App name is required."
//     : !filter?.party_name
//     ? "Party name is required."
//     : !filter?.ac_no
//     ? "Please select an assembly number to load BLA / BLE records."
//     : "";

//   const { data, isLoading, isFetching } = useQuery(
//     ["getBlaBleList", debouncedFilter],
//     () => getBlaBleList(debouncedFilter),
//     { enabled: hasRequiredListParams }
//   );

//   const list = useMemo(() => data?.results || [], [data]);

//   useEffect(() => {
//     return () => {
//       if (preview?.startsWith("blob:")) {
//         URL.revokeObjectURL(preview);
//       }
//     };
//   }, [preview]);

//   useEffect(() => {
//     if (!filter.ac_no && assemblyOptions.length) {
//       const firstAssembly = assemblyOptions[0];
//       setSelectedAssembly(firstAssembly);
//       setFilter((current) => ({
//         ...current,
//         ac_no: firstAssembly.value,
//         offset: 0,
//         currentPage: 0,
//       }));
//     }
//   }, [assemblyOptions, filter.ac_no]);

//   const resetForm = () => {
//     setFormValue(initialForm);
//     setInitialValue(initialForm);
//     setFormError({});
//     setPreview(PLACEHOLDER_AVATAR);
//     setIsEdit(false);
//   };

//   const openAddModal = () => {
//     resetForm();
//     setIsOpen(true);
//   };

//   const setValidationError = (error) => {
//     setFormError({ ...error });
//   };

//   const handleOnChange = async (name, value) => {
//     const stateObj = { ...formValue, [name]: value };
//     setFormValue(stateObj);

//     if (formError && Object.keys(formError).length) {
//       const error = await checkFormError(stateObj, blaBleValidation);
//       setValidationError(error === true ? {} : error);
//     }
//   };

//   const validateImage = (file) => {
//     if (!file) return "";
//     if (!IMAGE_TYPES.includes(file.type)) {
//       return "Only JPG, PNG, or WEBP images are allowed";
//     }
//     if (file.size > MAX_IMAGE_SIZE) {
//       return "Image size must be 2 MB or less";
//     }
//     return "";
//   };

//   const handleImageChange = (file) => {
//     const imageError = validateImage(file);
//     if (imageError) {
//       setFormError((current) => ({ ...current, profile_image: imageError }));
//       return;
//     }

//     const nextPreview = file ? URL.createObjectURL(file) : PLACEHOLDER_AVATAR;
//     setPreview((current) => {
//       if (current?.startsWith("blob:")) {
//         URL.revokeObjectURL(current);
//       }
//       return nextPreview;
//     });
//     setFormValue((current) => ({
//       ...current,
//       profile_image: file || "",
//       remove_profile_image: false,
//     }));
//     setFormError((current) => ({ ...current, profile_image: "" }));
//   };

//   const removeImage = () => {
//     setPreview((current) => {
//       if (current?.startsWith("blob:")) {
//         URL.revokeObjectURL(current);
//       }
//       return PLACEHOLDER_AVATAR;
//     });
//     setFormValue((current) => ({
//       ...current,
//       profile_image: "",
//       remove_profile_image: true,
//     }));
//     if (fileRef.current) {
//       fileRef.current.value = "";
//     }
//   };

//   const handleSubmit = async () => {
//     const validationResult = await checkFormError(formValue, blaBleValidation);
//     const imageError =
//       formValue.profile_image instanceof File
//         ? validateImage(formValue.profile_image)
//         : "";

//     if (validationResult === true && !imageError) {
//       setIsLoadding(true);
//       const formData = buildPayload(formValue, userLogin);
//       if (isEdit) {
//         updateMutation.mutate({ id: getRecordId(formValue), formData });
//       } else {
//         addMutation.mutate(formData);
//       }
//     } else {
//       setIsLoadding(false);
//       setValidationError({
//         ...(validationResult === true ? {} : validationResult),
//         ...(imageError ? { profile_image: imageError } : {}),
//       });
//     }
//   };

//   const onSuccessResponse = (message) => {
//     toast.success(message?.message || message || "success");
//     queryClient.invalidateQueries("getBlaBleList");
//     setIsLoadding(false);
//     setIsOpen(false);
//     setOpenDel(false);
//     resetForm();
//   };

//   const onErrorResponse = (error) => {
//     toast.error(getResposeError(error || "server error") || "server error");
//     setIsLoadding(false);
//   };

//   const addMutation = useMutation(addBlaBle, {
//     onSuccess: (res) => {
//       if (res?.success) {
//         onSuccessResponse(res);
//       } else {
//         onErrorResponse(res?.error || res);
//       }
//     },
//     onError: onErrorResponse,
//   });

//   const updateMutation = useMutation(updateBlaBle, {
//     onSuccess: (res) => {
//       if (res?.success) {
//         onSuccessResponse(res);
//       } else {
//         onErrorResponse(res?.error || res);
//       }
//     },
//     onError: onErrorResponse,
//   });

//   const deleteMutation = useMutation(deleteBlaBle, {
//     onSuccess: (res) => {
//       if (res?.success) {
//         onSuccessResponse(res);
//       } else {
//         onErrorResponse(res?.error || res);
//       }
//     },
//     onError: onErrorResponse,
//   });

//   const handleEditAction = (item) => {
//     const record = normalizeRecord(item);
//     setFormValue(record);
//     setInitialValue(record);
//     setPreview(record.profile_image || PLACEHOLDER_AVATAR);
//     setFormError({});
//     setIsEdit(true);
//     setIsOpen(true);
//   };

//   const handleViewAction = async (item) => {
//     const id = getRecordId(item);
//     setSelectedRecord(normalizeRecord(item));
//     setIsViewOpen(true);
//     if (id) {
//       const res = await getBlaBleDetails({ id });
//       if (res?.success && res?.results) {
//         setSelectedRecord(normalizeRecord(res.results));
//       }
//     }
//   };

//   const handleDelete = () => {
//     if (deleteId) {
//       setIsLoadding(true);
//       deleteMutation.mutate({ id: deleteId });
//     }
//   };

//   const handlePageClick = (data) => {
//     const currentPage = data.selected;
//     setFilter((current) => ({
//       ...current,
//       offset: currentPage * current.limit,
//       currentPage,
//     }));
//   };

//   const updateSearch = ({ target: { value } }) => {
//     setFilter((current) => ({
//       ...current,
//       search: value,
//       offset: 0,
//       currentPage: 0,
//     }));
//   };

//   const handleAssemblyFilterChange = (option) => {
//     setSelectedAssembly(option);
//     setFilter((current) => ({
//       ...current,
//       ac_no: option?.value || "",
//       offset: 0,
//       currentPage: 0,
//     }));
//   };

// const columns = [
//   { Header: "Profile Picture", accessor: "profile_image" },
//   { Header: "Name", accessor: "name" },
//   { Header: "Relative Name", accessor: "rel_name" },
//   { Header: "Mobile", accessor: "mobile" },
//   { Header: "EPIC No", accessor: "epic_no" },
//   { Header: "Assembly No", accessor: "assembly_no" },
//   { Header: "Booth No", accessor: "booth_no" },
//   { Header: "Type", accessor: "type" },
//   { Header: "Gender", accessor: "gender" },
//   { Header: "Party Name", accessor: "party_name" },
//   { Header: "Address", accessor: "address" },
//   { Header: "Status", accessor: "status" },
//   { Header: "Action", accessor: "action" },
// ];
//   const rowDataList = (dataList) =>
//   dataList.map((item) => {
//     const record = normalizeRecord(item);
//     const id = getRecordId(record);
//     return {
//       ...record,
//       profile_image: (
//         <img
//           className="bla-ble-avatar"
//           src={record.profile_image || PLACEHOLDER_AVATAR}
//           alt={record.name || "BLA/BLE"}
//           onError={({ currentTarget }) => {
//             currentTarget.src = PLACEHOLDER_AVATAR;
//           }}
//         />
//       ),
//       name: valueOrDash(record.name),
//       mobile: valueOrDash(record.mobile),
//       epic_no: valueOrDash(record.epic_no),
//       assembly_no: valueOrDash(record.assembly_no),
//       booth_no: valueOrDash(record.booth_no),
//       type: valueOrDash(record.type || "BLA"),
//       gender: valueOrDash(record.gender),
//       rel_name: valueOrDash(record.rel_name),
//       party_name: valueOrDash(record.party_name || userLogin?.party_name),
//       address: valueOrDash(record.address),
//       status: (
//         <span className={`bla-ble-status ${record.is_active ? "" : "inactive"}`}>
//           {record.is_active ? "Active" : "Inactive"}
//         </span>
//       ),
//       action: (
//         <div className="bla-ble-actions">
//           <button
//             type="button"
//             className="bla-ble-action-btn"
//             onClick={() => handleViewAction(record)}
//           >
//             <BsEye /> View
//           </button>
//           <button
//             type="button"
//             className="bla-ble-action-btn"
//             onClick={() => handleEditAction(record)}
//           >
//             <FaPencilAlt /> Edit
//           </button>
//           <button
//             type="button"
//             className="bla-ble-action-btn delete"
//             onClick={() => {
//               setDeleteId(id);
//               setOpenDel(true);
//             }}
//           >
//             <FaTrash /> Delete
//           </button>
//         </div>
//       ),
//     };
//   });

//   const renderInput = ({ name, label, required, maxLength }) => {
//     if (name === "assembly_no" && assemblyOptions.length) {
//       return (
//         <div className="bla-ble-dropdown-field" key={name}>
//           <Label className="modal_label">
//             {label}
//             <span className="style_for_star">{required ? "*" : ""}</span>
//           </Label>
//           <Dropdown
//             placeholder="Select Assembly Number"
//             options={assemblyOptions}
//             valueText="value"
//             labelText="label"
//             selectedOption={
//               assemblyOptions.find(
//                 (option) => option.value === String(formValue?.assembly_no)
//               ) || null
//             }
//             setSelectedOption={(option) =>
//               handleOnChange("assembly_no", option?.value || "")
//             }
//             focus={!!formError?.assembly_no}
//             error={formError?.assembly_no}
//             classNamePrefix="anvRc_controller"
//             isClearable
//           />
//         </div>
//       );
//     }

//     return (
//       <InputField
//         key={name}
//         className="modal_input"
//         label={label}
//         labelClass="modal_label"
//         labelSpan={required ? "*" : ""}
//         labelSpanClass="style_for_star"
//         placeholder={label}
//         name={name}
//         maxLength={maxLength}
//         focus={!!formError?.[name]}
//         error={formError?.[name]}
//         value={formValue?.[name] || ""}
//         onChange={({ target: { name: fieldName, value } }) =>
//           handleOnChange(fieldName, value)
//         }
//       />
//     );
//   };

//   const renderDetailCard = (title, fields) => (
//     <div className="bla-ble-detail-card">
//       <h4 className="bla-ble-section-title">{title}</h4>
//       <div className="bla-ble-detail-grid">
//         {fields.map(({ name, label }) => (
//           <div className="bla-ble-detail-item" key={name}>
//             <label>{label}</label>
//             <span>{valueOrDash(selectedRecord?.[name])}</span>
//           </div>
//         ))}
//       </div>
//     </div>
//   );

//   return (
//     <>
//       <div className="ques_container bla-ble-page">
//         <Breadcrumbs
//           active="BLA / BLE"
//           action={
//             <button className="addPlan" onClick={openAddModal}>
//               Add BLA / BLE
//             </button>
//           }
//         />

//         <div className="bla-ble-toolbar">
//           <div className="bla-ble-filter">
//             <Label className="modal_label">Assembly Number</Label>
//             <Dropdown
//               placeholder="Select Assembly Number"
//               options={assemblyOptions}
//               valueText="value"
//               labelText="label"
//               selectedOption={selectedAssembly}
//               setSelectedOption={handleAssemblyFilterChange}
//               classNamePrefix="anvRc_controller"
//               isClearable
//             />
//           </div>
//           <div className="bla-ble-search">
//             <InputField
//               className="anvSearch_input"
//               placeholder="Search"
//               name="search"
//               value={filter.search}
//               preAddon={<FaSearch />}
//               onChange={updateSearch}
//             />
//           </div>
//         </div>

//         {listParamError && (
//           <div className="bla-ble-alert">{listParamError}</div>
//         )}

//         <CustomReactTable
//           columns={columns}
//           data={rowDataList(list)}
//           tableLoading={hasRequiredListParams && (isLoading || isFetching)}
//           containerClassName="bla-ble-table-wrap"
//           tableClassName="bla-ble-table"
//         />
//       </div>

//       {list.length > 0 && (
//         <CustomPagination
//           onPageChange={handlePageClick}
//           currentPage={filter.currentPage}
//           pageCount={Math.ceil((data?.count || 0) / filter.limit)}
//         />
//       )}

//       <InputModal
//         isOpen={isOpen}
//         size="xl"
//         className="anvFleetType_modal"
//         customeClassName="bla-ble-form"
//         headerName={isEdit ? "Edit BLA / BLE" : "Add BLA / BLE"}
//         toggle={() => {
//           setIsOpen(!isOpen);
//           if (isOpen) resetForm();
//         }}
//         submitLabel={isEdit ? "Update" : "Add"}
//         onSubmit={handleSubmit}
//         disabled={
//           isEdit
//             ? JSON.stringify(formValue) === JSON.stringify(initialValue)
//             : false
//         }
//         isLoadding={isLoadding}
//         inputProps={
//           <div className="bla-ble-form">
//             <div className="bla-ble-image-field">
//               <button
//                 type="button"
//                 className="bla-ble-image-picker"
//                 onClick={() => fileRef.current?.click()}
//               >
//                 <img
//                   src={preview || PLACEHOLDER_AVATAR}
//                   alt="Profile preview"
//                   onError={({ currentTarget }) => {
//                     currentTarget.src = PLACEHOLDER_AVATAR;
//                   }}
//                 />
//                 <span className="bla-ble-image-overlay">
//                   {preview && preview !== PLACEHOLDER_AVATAR ? (
//                     <FaPencilAlt />
//                   ) : (
//                     <FaUpload />
//                   )}
//                 </span>
//               </button>
//               <input
//                 ref={fileRef}
//                 type="file"
//                 accept="image/png,image/jpeg,image/jpg,image/webp"
//                 hidden
//                 onChange={({ target: { files } }) => handleImageChange(files?.[0])}
//               />
//               <div>
//                 <button
//                   type="button"
//                   className="bla-ble-remove-image"
//                   onClick={removeImage}
//                 >
//                   Remove image
//                 </button>
//                 {formError?.profile_image && (
//                   <div className="bla-ble-field-error">{formError.profile_image}</div>
//                 )}
//               </div>
//             </div>

//             <div className="bla-ble-form-section">
//               <h4 className="bla-ble-section-title">Basic Information</h4>
//               <div className="bla-ble-form-grid">{basicFields.map(renderInput)}</div>
//             </div>

//             <div className="bla-ble-form-section">
//               <h4 className="bla-ble-section-title">Extra Information</h4>
//               <div className="bla-ble-form-grid">{extraFields.map(renderInput)}</div>
//             </div>

//             <div className="bla-ble-form-section">
//               <h4 className="bla-ble-section-title">Description Information</h4>
//               <div className="bla-ble-form-grid">{descriptionFields.map(renderInput)}</div>
//             </div>
//           </div>
//         }
//       />

//       <Modal
//         size="lg"
//         isOpen={isViewOpen}
//         toggle={() => setIsViewOpen(!isViewOpen)}
//         centered
//       >
//         <ModalHeader toggle={() => setIsViewOpen(!isViewOpen)}>
//           View BLA / BLE
//         </ModalHeader>
//         <ModalBody>
//           {selectedRecord && (
//             <>
//               <div className="bla-ble-view-head">
//                 <img
//                   className="bla-ble-view-avatar"
//                   src={selectedRecord.profile_image || PLACEHOLDER_AVATAR}
//                   alt={selectedRecord.name || "BLA/BLE"}
//                   onError={({ currentTarget }) => {
//                     currentTarget.src = PLACEHOLDER_AVATAR;
//                   }}
//                 />
//                 <div>
//                   <h3 className="bla-ble-view-title">
//                     {valueOrDash(selectedRecord.name)}
//                   </h3>
//                   <p className="bla-ble-view-subtitle">
//                     {valueOrDash(selectedRecord.mobile)}
//                   </p>
//                 </div>
//               </div>
//               {renderDetailCard("Basic Information", basicFields)}
//               {renderDetailCard("Extra Information", extraFields)}
//               {renderDetailCard("Description Information", descriptionFields)}
//             </>
//           )}
//         </ModalBody>
//       </Modal>

//       <ConfirmModal
//         isOpen={openDel}
//         toggle={() => {
//           setOpenDel(!openDel);
//           setDeleteId("");
//         }}
//         message="Are you sure you want to delete this record?"
//         submitLabel="Delete"
//         onSubmit={handleDelete}
//       />
//     </>
//   );
// };





import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import { Label, Modal, ModalBody, ModalHeader } from "reactstrap";
import { BsEye } from "react-icons/bs";
import { FaPencilAlt, FaSearch, FaTrash, FaUpload } from "react-icons/fa";
import { toast } from "react-toastify";
import { useMutation, useQuery, useQueryClient } from "react-query";

import Breadcrumbs from "../../Component/Common/Breadcrumbs";
import ConfirmModal from "../../Component/Common/ConstomModal/ConfirmModal";
import CustomPagination from "../../Component/Common/CustomPagination";
import { CustomReactTable } from "../../Component/Common/CustomReactTable";
import Dropdown from "../../Component/Common/Dropdown";
import InputModal from "../../Component/Common/ConstomModal/InputModal";
import { InputField } from "../../Component/Common/InputField";
import useDebounce from "../../helper/customhook";
import {
  checkFormError,
  getResposeError,
  handleKeyDown,
  FEATURES,
  hasAccess,
  getAccessLevel,
  ACCESS,
} from "../../helper";
import { getStorage } from "../../helper/storage";
import {
  addBlaBle,
  deleteBlaBle,
  getBlaBleDetails,
  getBlaBleList,
  updateBlaBle,
} from "../../services/blaBleService";
import { blaBleValidation } from "../../helper/errorSchema";
import UserContext from "../../helper/UserContext";
import "./BlaBle.css";
import Cropper from "react-easy-crop";
const PAGE_SIZE = 20;
// When a filter is active and the backend appears to ignore the filter
// params (i.e. it keeps returning the same count as the unfiltered list),
// we fall back to fetching a much larger page and filtering client-side.
const FALLBACK_FILTER_PAGE_SIZE = 1000;
const MAX_IMAGE_SIZE = 2 * 1024 * 1024;
const IMAGE_TYPES = ["image/jpeg", "image/jpg", "image/png", "image/webp"];
const PLACEHOLDER_AVATAR =
  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='160' height='160' viewBox='0 0 160 160'%3E%3Crect width='160' height='160' fill='%23eef2f7'/%3E%3Ccircle cx='80' cy='61' r='31' fill='%2395a3b8'/%3E%3Cpath d='M28 139c8-32 29-49 52-49s44 17 52 49' fill='%2395a3b8'/%3E%3C/svg%3E";
const createImage = (url) =>
  new Promise((resolve, reject) => {
    const image = new Image();
    image.crossOrigin = "anonymous";
    image.onload = () => resolve(image);
    image.onerror = reject;
    image.src = url;
  });

const getCroppedImageBlob = async (imageSrc, cropAreaPixels, outputSize = 480) => {
  const image = await createImage(imageSrc);
  const canvas = document.createElement("canvas");
  canvas.width = outputSize;
  canvas.height = outputSize;
  const ctx = canvas.getContext("2d");

  ctx.drawImage(
    image,
    cropAreaPixels.x,
    cropAreaPixels.y,
    cropAreaPixels.width,
    cropAreaPixels.height,
    0,
    0,
    outputSize,
    outputSize
  );

  return new Promise((resolve) => {
    canvas.toBlob((blob) => resolve(blob), "image/jpeg", 0.92);
  });
};
const basicFields = [
  { name: "name", label: "Name", required: true },
  { name: "mobile", label: "Mobile Number", required: true, maxLength: 10 },
  { name: "epic_no", label: "EPIC Number", required: true },
  { name: "assembly_no", label: "Assembly Number" },
  { name: "booth_no", label: "Booth Number" },
];

const extraFields = Array.from({ length: 10 }, (_, index) => ({
  name: `extra${index + 1}`,
  label: `Extra ${index + 1}`,
}));

const descriptionFields = Array.from({ length: 5 }, (_, index) => ({
  name: `description${index + 1}`,
  label: `Description ${index + 1}`,
}));

const initialForm = [...basicFields, ...extraFields, ...descriptionFields].reduce(
  (acc, field) => ({ ...acc, [field.name]: "" }),
  {
    profile_image: "",
    is_active: true,
    remove_profile_image: false,
  }
);

const TYPE_OPTIONS = [
  { label: "BLA", value: "BLA" },
  { label: "BLE", value: "BLE" },
];

const FILTER_KEYS = ["name", "rel_name", "mobile", "type"];

const getRecordId = (item) => item?.uuid || item?.id;

const getImageUrl = (item) =>
  item?.profile_image ||
  item?.profile_image_url ||
  item?.image ||
  item?.image_url ||
  "";

const valueOrDash = (value) =>
  value === null || value === undefined || value === "" ? "-" : value;

const getAssemblyNumbers = (userLogin, user) =>
  user?.appDetails?.assembly_number ||
  userLogin?.appDetails?.assembly_number ||
  [];

const normalizeRecord = (item = {}) => ({
  ...initialForm,
  ...item,
  mobile: item?.mobile || item?.mobile_number || item?.mobile_no || "",
  epic_no: item?.epic_no || item?.epic_number || item?.epic || "",
  assembly_no: item?.assembly_no || item?.assembly_number || "",
  booth_no: item?.booth_no || item?.booth_number || "",
  type: item?.type || "BLA",
  gender: item?.gender || "",
  rel_name: item?.rel_name || item?.relative_name || "",
  party_name: item?.party_name || "",
  address: item?.address || "",
  profile_image: getImageUrl(item),
  is_active:
    item?.is_active === undefined || item?.is_active === null
      ? item?.status !== false
      : item?.is_active,
});

const buildPayload = (formValue, userLogin) => {
  const formData = new FormData();
  [...basicFields, ...extraFields, ...descriptionFields].forEach(({ name }) => {
    if (name === "assembly_no") {
      formData.append("ac_no", formValue?.assembly_no ?? "");
      formData.append("assembly_no", formValue?.assembly_no ?? "");
      return;
    }
    formData.append(name, formValue?.[name] ?? "");
  });

  formData.append("is_active", formValue?.is_active ? "true" : "false");

  if (userLogin?.app_name) {
    formData.append("app_name", userLogin.app_name);
  }
  if (userLogin?.party_name) {
    formData.append("party_name", userLogin.party_name);
  }

  if (formValue?.profile_image instanceof File) {
    formData.append("profile_image", formValue.profile_image);
  }
  if (formValue?.remove_profile_image) {
    formData.append("remove_profile_image", "true");
  }

  return formData;
};

// Applies the same filters we send to the API, but on the frontend.
// Used as a fallback when the backend doesn't actually support these
// query params (see hasActiveFallbackFilter / fallback detection below).
const applyClientFilters = (records, filterValues) => {
  const name = filterValues?.name?.trim().toLowerCase();
  const relName = filterValues?.rel_name?.trim().toLowerCase();
  const mobile = filterValues?.mobile?.trim();
  const type = filterValues?.type?.trim().toLowerCase();

  if (!name && !relName && !mobile && !type) return records;

  return records.filter((item) => {
    const record = normalizeRecord(item);
    if (name && !String(record.name || "").toLowerCase().includes(name)) {
      return false;
    }
    if (
      relName &&
      !String(record.rel_name || "").toLowerCase().includes(relName)
    ) {
      return false;
    }
    if (mobile && !String(record.mobile || "").includes(mobile)) {
      return false;
    }
    if (type && String(record.type || "").toLowerCase() !== type) {
      return false;
    }
    return true;
  });
};

export const BlaBle = () => {
  const userLogin = getStorage("logged-in");
  const { user } = useContext(UserContext);
  const queryClient = useQueryClient();
  const fileRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [isViewOpen, setIsViewOpen] = useState(false);
  const [openDel, setOpenDel] = useState(false);
  const [deleteId, setDeleteId] = useState("");
  const [formValue, setFormValue] = useState(initialForm);
  const [initialValue, setInitialValue] = useState(initialForm);
  const [formError, setFormError] = useState({});
  const [preview, setPreview] = useState(PLACEHOLDER_AVATAR);
const [cropModalOpen, setCropModalOpen] = useState(false);
const [rawImageSrc, setRawImageSrc] = useState(null);
const [crop, setCrop] = useState({ x: 0, y: 0 });
const [zoom, setZoom] = useState(1);
const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
const [previewModalOpen, setPreviewModalOpen] = useState(false);
const [previewImageSrc, setPreviewImageSrc] = useState(PLACEHOLDER_AVATAR);


  const [selectedRecord, setSelectedRecord] = useState(null);
  const [isLoadding, setIsLoadding] = useState(false);
  const [selectedAssembly, setSelectedAssembly] = useState(null);
  const [selectedTypeFilter, setSelectedTypeFilter] = useState(null);
  // Tracks whether we've detected that the backend ignores our filter
  // params, so we know to switch to the client-side fallback.
  const [backendFiltersUnsupported, setBackendFiltersUnsupported] = useState(false);
  const [filter, setFilter] = useState({
    limit: PAGE_SIZE,
    offset: 0,
    currentPage: 0,
    search: "",
    ordering: "-id",
    ac_no: "",
    name: "",
    rel_name: "",
    mobile: "",
    type: "",
    app_name: userLogin?.app_name,
    party_name: userLogin?.party_name,
  });
  const debouncedFilter = useDebounce(filter, 500);
  const assemblyOptions = useMemo(
    () =>
      getAssemblyNumbers(userLogin, user)
        .filter(Boolean)
        .map((assemblyNumber) => ({
          label: String(assemblyNumber),
          value: String(assemblyNumber),
        })),
    [userLogin, user]
  );
  const hasRequiredListParams = Boolean(
    debouncedFilter?.app_name &&
      debouncedFilter?.party_name &&
      debouncedFilter?.ac_no
  );
  const listParamError = !filter?.app_name
    ? "App name is required."
    : !filter?.party_name
    ? "Party name is required."
    : !filter?.ac_no
    ? "Please select an assembly number to load BLA / BLE records."
    : "";

  const hasActiveFilter = FILTER_KEYS.some((key) => Boolean(filter?.[key]));

  // Once any filter is active, if the backend has proven it doesn't
  // support these params, request a much larger page so we can filter
  // accurately on the frontend instead.
  const effectiveFilter = useMemo(() => {
    if (hasActiveFilter && backendFiltersUnsupported) {
      return { ...debouncedFilter, limit: FALLBACK_FILTER_PAGE_SIZE, offset: 0 };
    }
    return debouncedFilter;
  }, [debouncedFilter, hasActiveFilter, backendFiltersUnsupported]);

  const { data, isLoading, isFetching } = useQuery(
    ["getBlaBleList", effectiveFilter],
    () => getBlaBleList(effectiveFilter),
    { enabled: hasRequiredListParams }
  );

  // Detect whether the backend actually applied our filters. We compare
  // the filtered result count against an unfiltered baseline count for
  // the same assembly. If a filter is active but the count returned is
  // identical to what we'd expect from an unfiltered list (i.e. the
  // backend silently ignored the params), we flip on the client-side
  // fallback so results stay accurate from then on.
  const baselineFilter = useMemo(
    () => ({
      limit: 1,
      offset: 0,
      ordering: "-id",
      ac_no: debouncedFilter?.ac_no,
      app_name: debouncedFilter?.app_name,
      party_name: debouncedFilter?.party_name,
    }),
    [debouncedFilter?.ac_no, debouncedFilter?.app_name, debouncedFilter?.party_name]
  );

  const { data: baselineData } = useQuery(
    ["getBlaBleListBaseline", baselineFilter],
    () => getBlaBleList(baselineFilter),
    { enabled: hasRequiredListParams && hasActiveFilter && !backendFiltersUnsupported }
  );

  useEffect(() => {
    if (
      hasActiveFilter &&
      !backendFiltersUnsupported &&
      typeof data?.count === "number" &&
      typeof baselineData?.count === "number" &&
      data.count === baselineData.count &&
      baselineData.count > 0
    ) {
      setBackendFiltersUnsupported(true);
    }
  }, [hasActiveFilter, backendFiltersUnsupported, data?.count, baselineData?.count]);

  // Reset the "unsupported" flag once filters are cleared, so we always
  // re-check the backend the next time a filter is applied.
  useEffect(() => {
    if (!hasActiveFilter && backendFiltersUnsupported) {
      setBackendFiltersUnsupported(false);
    }
  }, [hasActiveFilter, backendFiltersUnsupported]);

  const rawList = useMemo(() => data?.results || [], [data]);
  const list = useMemo(() => {
    if (hasActiveFilter && backendFiltersUnsupported) {
      return applyClientFilters(rawList, filter);
    }
    return rawList;
  }, [rawList, hasActiveFilter, backendFiltersUnsupported, filter]);

  const effectiveCount =
    hasActiveFilter && backendFiltersUnsupported ? list.length : data?.count || 0;
  const effectiveLimit =
    hasActiveFilter && backendFiltersUnsupported ? list.length || 1 : filter.limit;

  useEffect(() => {
    return () => {
      if (preview?.startsWith("blob:")) {
        URL.revokeObjectURL(preview);
      }
    };
  }, [preview]);

  useEffect(() => {
    if (!filter.ac_no && assemblyOptions.length) {
      const firstAssembly = assemblyOptions[0];
      setSelectedAssembly(firstAssembly);
      setFilter((current) => ({
        ...current,
        ac_no: firstAssembly.value,
        offset: 0,
        currentPage: 0,
      }));
    }
  }, [assemblyOptions, filter.ac_no]);

  const resetForm = () => {
    setFormValue(initialForm);
    setInitialValue(initialForm);
    setFormError({});
    setPreview(PLACEHOLDER_AVATAR);
    setIsEdit(false);
  };

  const openAddModal = () => {
    resetForm();
    setIsOpen(true);
  };

  const setValidationError = (error) => {
    setFormError({ ...error });
  };

  const handleOnChange = async (name, value) => {
    const stateObj = { ...formValue, [name]: value };
    setFormValue(stateObj);

    if (formError && Object.keys(formError).length) {
      const error = await checkFormError(stateObj, blaBleValidation);
      setValidationError(error === true ? {} : error);
    }
  };

  const validateImage = (file) => {
    if (!file) return "";
    if (!IMAGE_TYPES.includes(file.type)) {
      return "Only JPG, PNG, or WEBP images are allowed";
    }
    if (file.size > MAX_IMAGE_SIZE) {
      return "Image size must be 2 MB or less";
    }
    return "";
  };

 const handleImageChange = (file) => {
  if (!file) return;
  const imageError = validateImage(file);
  if (imageError) {
    setFormError((current) => ({ ...current, profile_image: imageError }));
    return;
  }
  setFormError((current) => ({ ...current, profile_image: "" }));

  const reader = new FileReader();
  reader.onload = () => {
    setRawImageSrc(reader.result);
    setCrop({ x: 0, y: 0 });
    setZoom(1);
    setCropModalOpen(true);
  };
  reader.readAsDataURL(file);
};

const onCropComplete = useCallback((_, areaPixels) => {
  setCroppedAreaPixels(areaPixels);
}, []);

const handleCropConfirm = async () => {
  if (!rawImageSrc || !croppedAreaPixels) return;
  const blob = await getCroppedImageBlob(rawImageSrc, croppedAreaPixels);
  const croppedFile = new File([blob], "profile.jpg", { type: "image/jpeg" });
  const nextPreview = URL.createObjectURL(blob);

  setPreview((current) => {
    if (current?.startsWith("blob:")) {
      URL.revokeObjectURL(current);
    }
    return nextPreview;
  });
  setFormValue((current) => ({
    ...current,
    profile_image: croppedFile,
    remove_profile_image: false,
  }));

  setCropModalOpen(false);
  setRawImageSrc(null);
};

const handleThumbClick = () => {
  const hasRealImage = preview && preview !== PLACEHOLDER_AVATAR;
  if (hasRealImage) {
    setPreviewImageSrc(preview);
    setPreviewModalOpen(true);
  } else {
    fileRef.current?.click();
  }
};

  const removeImage = () => {
    setPreview((current) => {
      if (current?.startsWith("blob:")) {
        URL.revokeObjectURL(current);
      }
      return PLACEHOLDER_AVATAR;
    });
    setFormValue((current) => ({
      ...current,
      profile_image: "",
      remove_profile_image: true,
    }));
    if (fileRef.current) {
      fileRef.current.value = "";
    }
  };

  const handleSubmit = async () => {
    const validationResult = await checkFormError(formValue, blaBleValidation);
    const imageError =
      formValue.profile_image instanceof File
        ? validateImage(formValue.profile_image)
        : "";

    if (validationResult === true && !imageError) {
      setIsLoadding(true);
      const formData = buildPayload(formValue, userLogin);
      if (isEdit) {
        updateMutation.mutate({ id: getRecordId(formValue), formData });
      } else {
        addMutation.mutate(formData);
      }
    } else {
      setIsLoadding(false);
      setValidationError({
        ...(validationResult === true ? {} : validationResult),
        ...(imageError ? { profile_image: imageError } : {}),
      });
    }
  };

  const onSuccessResponse = (message) => {
    toast.success(message?.message || message || "success");
    queryClient.invalidateQueries("getBlaBleList");
    setIsLoadding(false);
    setIsOpen(false);
    setOpenDel(false);
    resetForm();
  };

  const onErrorResponse = (error) => {
    toast.error(getResposeError(error || "server error") || "server error");
    setIsLoadding(false);
  };

  const addMutation = useMutation(addBlaBle, {
    onSuccess: (res) => {
      if (res?.success) {
        onSuccessResponse(res);
      } else {
        onErrorResponse(res?.error || res);
      }
    },
    onError: onErrorResponse,
  });

  const updateMutation = useMutation(updateBlaBle, {
    onSuccess: (res) => {
      if (res?.success) {
        onSuccessResponse(res);
      } else {
        onErrorResponse(res?.error || res);
      }
    },
    onError: onErrorResponse,
  });

  const deleteMutation = useMutation(deleteBlaBle, {
    onSuccess: (res) => {
      if (res?.success) {
        onSuccessResponse(res);
      } else {
        onErrorResponse(res?.error || res);
      }
    },
    onError: onErrorResponse,
  });

  const handleEditAction = (item) => {
    const record = normalizeRecord(item);
    setFormValue(record);
    setInitialValue(record);
    setPreview(record.profile_image || PLACEHOLDER_AVATAR);
    setFormError({});
    setIsEdit(true);
    setIsOpen(true);
  };

  const handleViewAction = async (item) => {
    const id = getRecordId(item);
    setSelectedRecord(normalizeRecord(item));
    setIsViewOpen(true);
    if (id) {
      const res = await getBlaBleDetails({ id });
      if (res?.success && res?.results) {
        setSelectedRecord(normalizeRecord(res.results));
      }
    }
  };

  const handleDelete = () => {
    if (deleteId) {
      setIsLoadding(true);
      deleteMutation.mutate({ id: deleteId });
    }
  };

  const handlePageClick = (data) => {
    const currentPage = data.selected;
    setFilter((current) => ({
      ...current,
      offset: currentPage * current.limit,
      currentPage,
    }));
  };

  const updateSearch = ({ target: { value } }) => {
    setFilter((current) => ({
      ...current,
      search: value,
      offset: 0,
      currentPage: 0,
    }));
  };

  const updateListFilter = (values) => {
    setFilter((current) => ({
      ...current,
      ...values,
      offset: 0,
      currentPage: 0,
    }));
  };

  const handleClearFilters = () => {
    setSelectedTypeFilter(null);
    updateListFilter({ name: "", rel_name: "", mobile: "", type: "" });
  };

  const handleAssemblyFilterChange = (option) => {
    setSelectedAssembly(option);
    setFilter((current) => ({
      ...current,
      ac_no: option?.value || "",
      offset: 0,
      currentPage: 0,
    }));
  };

const columns = [
  { Header: "Profile Picture", accessor: "profile_image" },
  { Header: "Name", accessor: "name" },
  { Header: "Relative Name", accessor: "rel_name" },
  { Header: "Mobile", accessor: "mobile" },
  { Header: "EPIC No", accessor: "epic_no" },
  { Header: "Assembly No", accessor: "assembly_no" },
  { Header: "Booth No", accessor: "booth_no" },
  { Header: "Type", accessor: "type" },
  { Header: "Gender", accessor: "gender" },
  { Header: "Party Name", accessor: "party_name" },
  { Header: "Address", accessor: "address" },
  { Header: "Status", accessor: "status" },
  { Header: "Action", accessor: "action" },
];
  const rowDataList = (dataList) =>
  dataList.map((item) => {
    const record = normalizeRecord(item);
    const id = getRecordId(record);
    return {
      ...record,
      profile_image: (
        <img
          className="bla-ble-avatar"
          src={record.profile_image || PLACEHOLDER_AVATAR}
          alt={record.name || "BLA/BLE"}
          onError={({ currentTarget }) => {
            currentTarget.src = PLACEHOLDER_AVATAR;
          }}
        />
      ),
      name: valueOrDash(record.name),
      mobile: valueOrDash(record.mobile),
      epic_no: valueOrDash(record.epic_no),
      assembly_no: valueOrDash(record.assembly_no),
      booth_no: valueOrDash(record.booth_no),
      type: valueOrDash(record.type || "BLA"),
      gender: valueOrDash(record.gender),
      rel_name: valueOrDash(record.rel_name),
      party_name: valueOrDash(record.party_name || userLogin?.party_name),
      address: valueOrDash(record.address),
      status: (
        <span className={`bla-ble-status ${record.is_active ? "" : "inactive"}`}>
          {record.is_active ? "Active" : "Inactive"}
        </span>
      ),
      // action: (
      //   <div className="bla-ble-actions">
      //     <button
      //       type="button"
      //       className="bla-ble-action-btn"
      //       onClick={() => handleViewAction(record)}
      //     >
      //       <BsEye /> View
      //     </button>
      //     <button
      //       type="button"
      //       className="bla-ble-action-btn"
      //       onClick={() => handleEditAction(record)}
      //     >
      //       <FaPencilAlt /> Edit
      //     </button>
      //     <button
      //       type="button"
      //       className="bla-ble-action-btn delete"
      //       onClick={() => {
      //         setDeleteId(id);
      //         setOpenDel(true);
      //       }}
      //     >
      //       <FaTrash /> Delete
      //     </button>
      //   </div>
      // ),
      action: (
  <div className="bla-ble-actions">
    {/* View — all user types */}
    <button
      type="button"
      className="bla-ble-action-btn"
      onClick={() => handleViewAction(record)}
    >
      <BsEye /> View
    </button>

    {/* Edit — Super Admin, Sub Admin, Admin, Booth Manager, Volunteer (helper/roles.config.js) */}
    {hasAccess(userLogin?.user_type, FEATURES.BLA_BLE, ACCESS.LIMITED) && (
      <button
        type="button"
        className="bla-ble-action-btn"
        onClick={() => handleEditAction(record)}
      >
        <FaPencilAlt /> Edit
      </button>
    )}

    {/* Delete — Super Admin only */}
    {getAccessLevel(userLogin?.user_type, FEATURES.BLA_BLE) === ACCESS.FULL && (
      <button
        type="button"
        className="bla-ble-action-btn delete"
        onClick={() => {
          setDeleteId(id);
          setOpenDel(true);
        }}
      >
        <FaTrash /> Delete
      </button>
    )}
  </div>
),
    };
  });

  const renderInput = ({ name, label, required, maxLength }) => {
    if (name === "assembly_no" && assemblyOptions.length) {
      return (
        <div className="bla-ble-dropdown-field" key={name}>
          <Label className="modal_label">
            {label}
            <span className="style_for_star">{required ? "*" : ""}</span>
          </Label>
          <Dropdown
            placeholder="Select Assembly Number"
            options={assemblyOptions}
            valueText="value"
            labelText="label"
            selectedOption={
              assemblyOptions.find(
                (option) => option.value === String(formValue?.assembly_no)
              ) || null
            }
            setSelectedOption={(option) =>
              handleOnChange("assembly_no", option?.value || "")
            }
            focus={!!formError?.assembly_no}
            error={formError?.assembly_no}
            classNamePrefix="anvRc_controller"
            isClearable
          />
        </div>
      );
    }

    return (
      <InputField
        key={name}
        className="modal_input"
        label={label}
        labelClass="modal_label"
        labelSpan={required ? "*" : ""}
        labelSpanClass="style_for_star"
        placeholder={label}
        name={name}
        maxLength={maxLength}
        focus={!!formError?.[name]}
        error={formError?.[name]}
        value={formValue?.[name] || ""}
        onChange={({ target: { name: fieldName, value } }) =>
          handleOnChange(fieldName, value)
        }
      />
    );
  };

  const renderDetailCard = (title, fields) => (
    <div className="bla-ble-detail-card">
      <h4 className="bla-ble-section-title">{title}</h4>
      <div className="bla-ble-detail-grid">
        {fields.map(({ name, label }) => (
          <div className="bla-ble-detail-item" key={name}>
            <label>{label}</label>
            <span>{valueOrDash(selectedRecord?.[name])}</span>
          </div>
        ))}
      </div>
    </div>
  );

  return (
    <>
      <div className="ques_container bla-ble-page">
        {/* <Breadcrumbs
          active="BLA / BLE"
          action={
            <button className="addPlan" onClick={openAddModal}>
              Add BLA / BLE
            </button>
          }
        /> */}
        <Breadcrumbs
  active="BLA / BLE"
  action={
    hasAccess(userLogin?.user_type, FEATURES.BLA_BLE, ACCESS.LIMITED) ? (
      <button className="addPlan" onClick={openAddModal}>
        Add BLA / BLE
      </button>
    ) : null
  }
/>

        <div className="bla-ble-toolbar">
          <div className="bla-ble-filter">
            <Label className="modal_label">Assembly Number</Label>
            <Dropdown
              placeholder="Select Assembly Number"
              options={assemblyOptions}
              valueText="value"
              labelText="label"
              selectedOption={selectedAssembly}
              setSelectedOption={handleAssemblyFilterChange}
              classNamePrefix="anvRc_controller"
              isClearable
            />
          </div>
          <div className="bla-ble-search">
            <InputField
              className="anvSearch_input"
              placeholder="Search"
              name="search"
              value={filter.search}
              preAddon={<FaSearch />}
              onChange={updateSearch}
            />
          </div>
        </div>

        <div className="bla-ble-toolbar2 bla-ble-advanced-filters">
          <div className="bla-ble-filter">
            <Label className="modal_label">First Name</Label>
            <InputField
              className="anvSearch_input"
              placeholder="First Name"
              name="name"
              value={filter.name}
              onChange={(e) => updateListFilter({ name: e.target.value })}
            />
          </div>
          <div className="bla-ble-filter">
            <Label className="modal_label">Last Name</Label>
            <InputField
              className="anvSearch_input"
              placeholder="Last Name (Relative)"
              name="rel_name"
              value={filter.rel_name}
              onChange={(e) => updateListFilter({ rel_name: e.target.value })}
            />
          </div>
          <div className="bla-ble-filter">
            <Label className="modal_label">Mobile Number</Label>
            <InputField
              className="anvSearch_input"
              placeholder="Mobile Number"
              name="mobile"
              maxLength={10}
              onKeyDown={handleKeyDown}
              value={filter.mobile}
              onChange={(e) => updateListFilter({ mobile: e.target.value })}
            />
          </div>
          <div className="bla-ble-filter2">
            <Label className="modal_label">Type</Label>
            <Dropdown
              placeholder="Select Type"
              options={TYPE_OPTIONS}
              valueText="value"
              labelText="label"
              isClearable
              selectedOption={selectedTypeFilter}
              setSelectedOption={(option) => {
                setSelectedTypeFilter(option);
                updateListFilter({ type: option?.value || "" });
              }}
              classNamePrefix="anvRc_controller"
            />
          </div>
          {hasActiveFilter && (
            <div className="bla-ble-filter bla-ble-clear-filter">
              <button
                type="button"
                className="mobile-visibility-toggle"
                onClick={handleClearFilters}
              >
                <span>Clear Filters</span>
              </button>
            </div>
          )}
        </div>

        {listParamError && (
          <div className="bla-ble-alert">{listParamError}</div>
        )}

        <CustomReactTable
          columns={columns}
          data={rowDataList(list)}
          tableLoading={hasRequiredListParams && (isLoading || isFetching)}
          containerClassName="bla-ble-table-wrap"
          tableClassName="bla-ble-table"
        />
      </div>

      {list.length > 0 && (
        <CustomPagination
          onPageChange={handlePageClick}
          currentPage={filter.currentPage}
          pageCount={Math.ceil(effectiveCount / effectiveLimit)}
        />
      )}

      <InputModal
        isOpen={isOpen}
        size="xl"
        className="anvFleetType_modal"
        customeClassName="bla-ble-form"
        headerName={isEdit ? "Edit BLA / BLE" : "Add BLA / BLE"}
        toggle={() => {
          setIsOpen(!isOpen);
          if (isOpen) resetForm();
        }}
        submitLabel={isEdit ? "Update" : "Add"}
        onSubmit={handleSubmit}
        disabled={
          isEdit
            ? JSON.stringify(formValue) === JSON.stringify(initialValue)
            : false
        }
        isLoadding={isLoadding}
        // inputProps={
        //   <div className="bla-ble-form">
        //     <div className="bla-ble-image-field">
        //       <button
        //         type="button"
        //         className="bla-ble-image-picker"
        //         onClick={() => fileRef.current?.click()}
        //       >
        //         <img
        //           src={preview || PLACEHOLDER_AVATAR}
        //           alt="Profile preview"
        //           onError={({ currentTarget }) => {
        //             currentTarget.src = PLACEHOLDER_AVATAR;
        //           }}
        //         />
        //         <span className="bla-ble-image-overlay">
        //           {preview && preview !== PLACEHOLDER_AVATAR ? (
        //             <FaPencilAlt />
        //           ) : (
        //             <FaUpload />
        //           )}
        //         </span>
        //       </button>
        //       <input
        //         ref={fileRef}
        //         type="file"
        //         accept="image/png,image/jpeg,image/jpg,image/webp"
        //         hidden
        //         onChange={({ target: { files } }) => handleImageChange(files?.[0])}
        //       />
        //       <div>
        //         <button
        //           type="button"
        //           className="bla-ble-remove-image"
        //           onClick={removeImage}
        //         >
        //           Remove image
        //         </button>
        //         {formError?.profile_image && (
        //           <div className="bla-ble-field-error">{formError.profile_image}</div>
        //         )}
        //       </div>
        //     </div>

        //     <div className="bla-ble-form-section">
        //       <h4 className="bla-ble-section-title">Basic Information</h4>
        //       <div className="bla-ble-form-grid">{basicFields.map(renderInput)}</div>
        //     </div>

        //     <div className="bla-ble-form-section">
        //       <h4 className="bla-ble-section-title">Extra Information</h4>
        //       <div className="bla-ble-form-grid">{extraFields.map(renderInput)}</div>
        //     </div>

        //     <div className="bla-ble-form-section">
        //       <h4 className="bla-ble-section-title">Description Information</h4>
        //       <div className="bla-ble-form-grid">{descriptionFields.map(renderInput)}</div>
        //     </div>
        //   </div>
        // }

        inputProps={
  <div className="bla-ble-form">
    <div className="bla-ble-image-field">
      <button
        type="button"
        className="bla-ble-image-picker"
        onClick={handleThumbClick}
        title={
          preview && preview !== PLACEHOLDER_AVATAR
            ? "View full photo"
            : "Upload photo"
        }
      >
        <img
          src={preview || PLACEHOLDER_AVATAR}
          alt="Profile preview"
          onError={({ currentTarget }) => {
            currentTarget.src = PLACEHOLDER_AVATAR;
          }}
        />
        <span className="bla-ble-image-overlay">
          {preview && preview !== PLACEHOLDER_AVATAR ? (
            <FaPencilAlt />
          ) : (
            <FaUpload />
          )}
        </span>
      </button>
      <input
        ref={fileRef}
        type="file"
        accept="image/png,image/jpeg,image/jpg,image/webp"
        hidden
        onChange={({ target: { files } }) => handleImageChange(files?.[0])}
      />
      <div className="bla-ble-image-actions">
        <button
          type="button"
          className="bla-ble-remove-image"
          onClick={() => fileRef.current?.click()}
        >
          {preview && preview !== PLACEHOLDER_AVATAR ? "Replace image" : "Upload image"}
        </button>
        {preview && preview !== PLACEHOLDER_AVATAR && (
          <button
            type="button"
            className="bla-ble-remove-image"
            onClick={removeImage}
          >
            Remove image
          </button>
        )}
        {formError?.profile_image && (
          <div className="bla-ble-field-error">{formError.profile_image}</div>
        )}
      </div>
    </div>

    <div className="bla-ble-form-section">
      <h4 className="bla-ble-section-title">Basic Information</h4>
      <div className="bla-ble-form-grid">{basicFields.map(renderInput)}</div>
    </div>

    <div className="bla-ble-form-section">
      <h4 className="bla-ble-section-title">Extra Information</h4>
      <div className="bla-ble-form-grid">{extraFields.map(renderInput)}</div>
    </div>

    <div className="bla-ble-form-section">
      <h4 className="bla-ble-section-title">Description Information</h4>
      <div className="bla-ble-form-grid">{descriptionFields.map(renderInput)}</div>
    </div>
  </div>
}
      />

      <Modal
        size="lg"
        isOpen={isViewOpen}
        toggle={() => setIsViewOpen(!isViewOpen)}
        centered
      >
        <ModalHeader toggle={() => setIsViewOpen(!isViewOpen)}>
          View BLA / BLE
        </ModalHeader>
        <ModalBody>
          {selectedRecord && (
            <>
              <div className="bla-ble-view-head">
                <button
  type="button"
  className="bla-ble-view-avatar-btn"
  onClick={() => {
    if (selectedRecord.profile_image) {
      setPreviewImageSrc(selectedRecord.profile_image);
      setPreviewModalOpen(true);
    }
  }}
  title={selectedRecord.profile_image ? "View full photo" : undefined}
  style={{ background: "none", border: "none", padding: 0, cursor: selectedRecord.profile_image ? "pointer" : "default" }}
>
  <img
    className="bla-ble-view-avatar"
    src={selectedRecord.profile_image || PLACEHOLDER_AVATAR}
    alt={selectedRecord.name || "BLA/BLE"}
    onError={({ currentTarget }) => {
      currentTarget.src = PLACEHOLDER_AVATAR;
    }}
  />
</button>
                <div>
                  <h3 className="bla-ble-view-title">
                    {valueOrDash(selectedRecord.name)}
                  </h3>
                  <p className="bla-ble-view-subtitle">
                    {valueOrDash(selectedRecord.mobile)}
                  </p>
                </div>
              </div>
              {renderDetailCard("Basic Information", basicFields)}
              {renderDetailCard("Extra Information", extraFields)}
              {renderDetailCard("Description Information", descriptionFields)}
            </>
          )}
        </ModalBody>
      </Modal>

      <ConfirmModal
        isOpen={openDel}
        toggle={() => {
          setOpenDel(!openDel);
          setDeleteId("");
        }}
        message="Are you sure you want to delete this record?"
        submitLabel="Delete"
        onSubmit={handleDelete}
      />

      <Modal
  size="md"
  isOpen={cropModalOpen}
  toggle={() => setCropModalOpen(false)}
  centered
>
  <ModalHeader toggle={() => setCropModalOpen(false)}>
    Crop Profile Photo
  </ModalHeader>
  <ModalBody>
    <div style={{ position: "relative", width: "100%", height: "300px" }}>
      {rawImageSrc && (
        <Cropper
          image={rawImageSrc}
          crop={crop}
          zoom={zoom}
          aspect={1}
          cropShape="round"
          showGrid={false}
          onCropChange={setCrop}
          onZoomChange={setZoom}
          onCropComplete={onCropComplete}
        />
      )}
    </div>
    <div style={{ display: "flex", alignItems: "center", gap: "10px", marginTop: "12px" }}>
      <span>Zoom</span>
      <input
        type="range"
        min={1}
        max={3}
        step={0.1}
        value={zoom}
        onChange={(e) => setZoom(Number(e.target.value))}
        style={{ flex: 1 }}
      />
    </div>
  </ModalBody>
  <div className="bla-ble-image-actions" style={{ padding: "12px 16px", justifyContent: "flex-end", display: "flex", gap: "10px" }}>
    <button type="button" className="bla-ble-remove-image" onClick={() => setCropModalOpen(false)}>
      Cancel
    </button>
    <button type="button" className="bla-ble-remove-image" onClick={handleCropConfirm}>
      Save
    </button>
  </div>
</Modal>

<Modal
  size="sm"
  isOpen={previewModalOpen}
  toggle={() => setPreviewModalOpen(false)}
  centered
>
  <ModalHeader toggle={() => setPreviewModalOpen(false)}>
    Profile Photo
  </ModalHeader>
  <ModalBody style={{ textAlign: "center" }}>
    <img
      src={previewImageSrc || PLACEHOLDER_AVATAR}
      alt="Profile full preview"
      style={{ maxWidth: "100%", borderRadius: "8px" }}
      onError={({ currentTarget }) => {
        currentTarget.src = PLACEHOLDER_AVATAR;
      }}
    />
  </ModalBody>
</Modal>
    </>
  );
};